// 支付类型图片

// 余额支付
export const PayImageAccount = Symbol("PayImageAccount");
// 饭卡
export const PayImageCard = Symbol("PayImageCard");
// 微信
export const PayImageWx = 5;
// 到付
export const PayImageArrivals = -1;
// 月结
export const PayImageMonth = 1;
// 试吃
export const PayImageTry =2;
// 员工餐
export const PayImageEmployee = 3;
// 转账
export const PayImageTransfer = 4;
// pos机
export const PayImagePos = Symbol("PayImagePos");

export const ImageMap = {
	[PayImageAccount]: require("@/assets/images/pay/pay_account.png"),
	[PayImageCard]: require("@/assets/images/pay/pay_card.png"),
	[PayImageWx]: require("@/assets/images/pay/pay_wechat.png"),
	[PayImageArrivals]: require("@/assets/images/pay/pay_arrivals.png"),
	[PayImageMonth]: require("@/assets/images/pay/pay_month.png"),
	[PayImageTry]: require("@/assets/images/pay/pay_try.png"),
	[PayImageEmployee]: require("@/assets/images/pay/pay_employee.png"),
	[PayImageTransfer]: require("@/assets/images/pay/pay_transfer.png"),
	[PayImagePos]: require("@/assets/images/pay/pay_pos.png"),
};
